/*!*
 * @author yueheqin
 * @date 2019/7/9
 * @project zujuanzaixian
 * @desc 共用弹框
 */
//     0题目类型，1题目答案，2题目解析，3题目知识点，4其他
const correctType = [
  {
    id: 0,
    name: '题目类型'
  },
  {
    id: 1,
    name: '题目答案'
  },
  {
    id: 2,
    name: '题目解析'
  },
  {
    id: 3,
    name: '题目知识点'
  },
  {
    id: 4,
    name: '其他'
  }
]

const paperSizeIcon = {
  'A4': 'iconA',
  'A4H': 'iconBhengshuanglan',
  'B4H': 'iconBhengshuanglan',
  'B5': 'iconB',
  'A3H': 'iconAhengshuanglan',
  '8KH': 'iconkhengshuanglan'
}

let state = {
  currentOprQues: {}, // 当前操作的试题
  currentOprTest: {}, // 当前操作的试卷
  currentDownDoc: '', // 下载的试卷ID暂存
  paperDownOption: {}, // 记录word样式设置
  paperDownParams: {}, // 记录word参数
  gradePopVisible: false, // 评分弹框
  correctPopVisible: false, // 纠错弹框
  collectPopVisible: false, // 收藏弹框
  paperDownPopVisible: false, // 试卷下载设置word样式弹框
  basketQuesListPopVisible: false // 试题篮试题列表弹框
}
let getters = {
  correctType () {
    return correctType
  },
  paperSizeIcon () {
    return paperSizeIcon
  }
}
let mutations = {
  updateCurrentQues (state, val) {
    console.log('mutations updateCurrentQues:', val)
    state.currentOprQues = val
  },
  updateCurrentTest (state, val) {
    state.currentOprTest = val
  },
  updateCurrentDownDoc (state, val) {
    state.currentDownDoc = val
  },
  updatePaperDownParams (state, val) {
    state.paperDownParams = val
  },
  updatePaperDownOption (state, val) {
    state.paperDownOption = val
  },
  updateGradePopVisible (state, val) {
    console.log('mutations updateGradePopVisible:', val)
    state.gradePopVisible = val
  },
  updateCorrectPopVisible (state, val) {
    console.log('mutations updateCorrectPopVisible:', val)
    state.correctPopVisible = val
  },
  updateCollectPopVisible (state, val) {
    console.log('mutations updateCollectPopVisible:', val)
    state.collectPopVisible = val
  },
  updatePaperDownPopVisible (state, val) {
    console.log('mutations updatePaperDownPopVisible:', val)
    state.paperDownPopVisible = val
  },
  updateBasketQuesListPopVisible (state, val) {
    console.log('mutations updateBasketQuesListPopVisible:', val)
    state.basketQuesListPopVisible = val
  }
}
let actions = {

}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}
